module.exports = "<div class=\"dropdown-item_name\" data-value=\"{{::option.Text}}\" dataclass=\"_optionText\" ng-bind-html=\"option.Text\"></div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/signup/guestsignupdelivery/address-item-template.html
 ** module id = 1018
 ** module chunks = 1
 **/